(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();
    }


    connectedCallback() {

      this.header = document.querySelector('.section-header');

      /* =====================================================
         VAMESCENT HERO HEADER
         ===================================================== */

      this.vameHeader = this.querySelector('[data-vame-header]');
      this.vameHeaderWrapper = this;


      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';


      this.headerBounds = {};


      this.setHeaderHeight();


      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );


      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }


      this.currentScrollTop = 0;
      this.preventReveal = false;


      this.predictiveSearch =
        this.querySelector('predictive-search');


      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);


      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );


      this.createObserver();


      /* =====================================================
         INITIALIZE HERO DETECTION
         ===================================================== */

      this.initVameHeroHeader();

    }


    /* =======================================================
       VAMESCENT HERO DETECTION
       ======================================================= */

    initVameHeroHeader() {

      if (!this.vameHeaderWrapper) {
        return;
      }


      /*
       * Solo aplicamos el comportamiento Hero en la
       * página principal.
       */

      if (document.body.classList.contains('template-product')) {
        return;
      }


      if (
        document.body.classList.contains('template-index') === false &&
        window.location.pathname !== '/'
      ) {
        return;
      }


      /*
       * Detectamos los Hero habituales de Dawn.
       */

      this.heroSection =
        document.querySelector('.banner') ||
        document.querySelector('.slideshow') ||
        document.querySelector('.image-banner') ||
        document.querySelector('[class*="banner"]');


      /*
       * Si no encontramos un Hero no hacemos nada.
       */

      if (!this.heroSection) {
        return;
      }


      /*
       * Estado inicial:
       * estamos arriba → header sobre Hero.
       */

      this.updateVameHeroHeader();


      /*
       * IntersectionObserver detecta cuándo el Hero
       * deja de estar debajo del header.
       */

      this.vameHeroObserver =
        new IntersectionObserver(

          (entries) => {

            const entry = entries[0];


            if (entry.isIntersecting) {

              this.vameHeaderWrapper.classList.add(
                'vame-header-over-hero'
              );

            } else {

              this.vameHeaderWrapper.classList.remove(
                'vame-header-over-hero'
              );

            }

          },

          {
            threshold: 0,

            rootMargin:
              `-${this.offsetHeight}px 0px 0px 0px`
          }

        );


      this.vameHeroObserver.observe(
        this.heroSection
      );

    }


    /* =======================================================
       INITIAL HERO STATE
       ======================================================= */

    updateVameHeroHeader() {

      if (!this.heroSection) {

        this.vameHeaderWrapper.classList.remove(
          'vame-header-over-hero'
        );

        return;

      }


      const heroRect =
        this.heroSection.getBoundingClientRect();


      if (
        heroRect.bottom >
        this.offsetHeight
      ) {

        this.vameHeaderWrapper.classList.add(
          'vame-header-over-hero'
        );

      } else {

        this.vameHeaderWrapper.classList.remove(
          'vame-header-over-hero'
        );

      }

    }


    /* =======================================================
       ORIGINAL DAWN STICKY HEADER
       ======================================================= */

    setHeaderHeight() {

      if (!this.header) {
        return;
      }

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }


    disconnectedCallback() {

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );


      if (this.vameHeroObserver) {

        this.vameHeroObserver.disconnect();

      }

    }


    createObserver() {

      let observer =
        new IntersectionObserver(

          (entries, observer) => {

            this.headerBounds =
              entries[0].intersectionRect;

            observer.disconnect();

          }

        );


      observer.observe(this.header);

    }


    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;


      /*
       * Actualizamos nuestro estado Hero.
       */

      if (this.heroSection) {

        this.updateVameHeroHeader();

      }


      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }


      if (
        scrollTop >
          this.currentScrollTop &&
        scrollTop >
          this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );


        if (this.preventHide) {
          return;
        }


        requestAnimationFrame(
          this.hide.bind(this)
        );


      } else if (
        scrollTop <
          this.currentScrollTop &&
        scrollTop >
          this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );


        if (!this.preventReveal) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        } else {

          window.clearTimeout(
            this.isScrolling
          );


          this.isScrolling =
            setTimeout(() => {

              this.preventReveal = false;

            }, 66);


          requestAnimationFrame(
            this.hide.bind(this)
          );

        }


      } else if (
        scrollTop <=
        this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );


        requestAnimationFrame(
          this.reset.bind(this)
        );

      }


      this.currentScrollTop =
        scrollTop;

    }


    hide() {

      if (this.headerIsAlwaysSticky) {
        return;
      }


      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );


      this.closeMenuDisclosure();
      this.closeSearchModal();

    }


    reveal() {

      if (this.headerIsAlwaysSticky) {
        return;
      }


      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );


      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }


    reset() {

      if (this.headerIsAlwaysSticky) {
        return;
      }


      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }


    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );


      this.disclosures.forEach(
        (disclosure) => disclosure.close()
      );

    }


    closeSearchModal() {

      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );


      if (this.searchModal) {

        this.searchModal.close(false);

      }

    }

  }


  customElements.define(
    'sticky-header',
    StickyHeader
  );


  } catch(e) { console.error(e); }
})();
})();
